const initState = {
  subtopics: [],
};

const companyProfileReducer = (state = initState, action) => {
  switch (action.type) {
    case "ADDED_COMPANY_PROFILE":
      return {
        ...state,
        addCompanyProfileSuccess: {
          message: action.message,
          type: "addCompanyProfileSuccess",
          id: action.id,
        },
      };
    case "ADDED_COMPANY_PROFILE_ERROR":
      return {
        ...state,
        addCompanyProfileError: {
          message: action.err.message,
          type: "addCompanyProfileError",
        },
      };

    case "UPDATED_COMPANY_PROFILE":
      return {
        ...state,
        updateCompanyProfileSuccess: {
          message: action.message,
          type: "updateCompanyProfileSuccess",
        },
      };
    case "UPDATED_COMPANY_PROFILE_ERROR":
      return {
        ...state,
        updateCompanyProfileError: {
          message: action.err.message,
          type: "updateCompanyProfileError",
        },
      };

    case "DELETED_COMPANY_PROFILE":
      return {
        ...state,
        deleteCompanyProfileSuccess: {
          message: action.message,
          type: "deleteCompanyProfileSuccess",
        },
      };

    case "DELETED_COMPANY_PROFILE_ERROR":
      return {
        ...state,
        deleteCompanyProfileError: {
          message: action.err.message,
          type: "deleteCompanyProfileError",
        },
      };

    default:
      return state;
  }
};

export default companyProfileReducer;
